import { ModalType } from "../modal/LeadModal";

export type HeaderAction =
    | { kind: "link"; to: string; label: string }
    | { kind: "cta"; label: string; modal: ModalType };

export function getHeaderActions(params: {
    isAuth: boolean;
    isAdmin: boolean;
}): HeaderAction[] {
    const { isAuth, isAdmin } = params;

    if (!isAuth) {
        return [
            { kind: "link", to: "/login", label: "Войти" },
            { kind: "cta", label: "Купить", modal: "order" },
        ];
    }

    if (isAuth && !isAdmin) {
        return [
            { kind: "link", to: "/personal-account", label: "Личный кабинет" },
            { kind: "cta", label: "Купить", modal: "order" },
        ];
    }

    return [
        { kind: "link", to: "/admin", label: "Админка" },
        { kind: "link", to: "/personal-account", label: "Личный кабинет" },
        { kind: "cta", label: "Купить", modal: "order" },
    ];
}
